/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PopupCreateDto } from '../../models/popup-create-dto';
import { PopupDto } from '../../models/popup-dto';

export interface PopupAdminControllerCreateV1$Params {
      body: PopupCreateDto
}

export function popupAdminControllerCreateV1(http: HttpClient, rootUrl: string, params: PopupAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
  const rb = new RequestBuilder(rootUrl, popupAdminControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PopupDto>;
    })
  );
}

popupAdminControllerCreateV1.PATH = '/api/v1/popups/admin';
